import { matchRoutes, type RouteObject } from 'react-router-dom';

type LazyRoute = RouteObject & { lazy?: () => Promise<Partial<RouteObject>> };

/** Approach B: resolve `lazy` routes matching the URL before the router exists (RR "SSR + lazy" pattern). */
export async function preResolveLazyRoutes(routes: RouteObject[], pathname: string): Promise<void> {
  const matches = matchRoutes(routes, pathname) ?? [];
  await Promise.all(
    matches.map(async (m) => {
      const route = m.route as LazyRoute;
      if (!route.lazy) return;
      const mod = await route.lazy();
      Object.assign(route, mod, { lazy: undefined });
    }),
  );
}
